/* eslint-disable no-unused-vars */
import {
  getInputSelector,
  updateFields,
  validatePhoneNumberCharacter,
  validateNameCharacter,
  updateFileName
} from './contact-form-functions';

$( () => {
  const forms = $( '.bs-section--careers-job-openings-content  .bs-div--form-wrapper' );
  if ( forms.length === 0 ) return;
  const setWrapperClass = ( selector, classNames ) =>
    forms.find( selector ).closest( 'p' ).addClass( classNames );

  const updateFocusedState = ( currentElement = null ) => {
    updateFields( forms.find( getInputSelector( true ) ) );
    updateFields( forms.find( 'select.wpcf7-form-control' ) );
  };

  forms.find( 'br' ).remove();

  forms.find( 'input[type="submit"]' ).each( ( i, button ) => {
    button = $( button );
    const form = button.closest( 'form' );
    form.find( '.form-bottom' ).append( button );
    const btnText = button.val() ? button.val() : 'Submit';
    const tag =
      $( `<div class="bs-pro-button bs-pro-button--primary-with-arrow btn-submit">
		<button class="bs-pro-button__container" type="submit" >${btnText}</button>
 </div>` );
    button.replaceWith( tag );
  } );
  forms.each( ( i, form ) => {
    form = $( form );
    form.find( '.bs-pro-button' ).append( form.find( '.wpcf7-spinner' ) );
  } );

  setWrapperClass( getInputSelector(), 'text-field' );
  setWrapperClass( 'textarea.wpcf7-form-control', 'textarea-field' );
  setWrapperClass( '.wpcf7-acceptance', 'acceptance-field' );
  setWrapperClass( '.bs-pro-button', 'form-submission' );
  setWrapperClass( '.wpcf7-file', 'file-upload' );

  forms.find( '.wpcf7-file' ).each( ( i, nativeFileField ) => {
    const fileField = $( nativeFileField );
    const fileFieldWrapper = fileField.closest( '.file-upload' );
    const label = fileFieldWrapper.find( '>label' );
    const tag =
      $( `<div class="bs-pro-button bs-pro-button--blue-outline btn-submit">
<button class="bs-pro-button__container" type="button" >${label.html()}</button>
</div>` );
    const fileNameWrapper = $( '<div class="file-name"></div>' );
    fileFieldWrapper.append( tag, fileNameWrapper );
    tag.on( 'click', () => {
      fileField.trigger( 'click' );
    } );
    fileField.on( 'change', () => {
      updateFileName( nativeFileField, fileNameWrapper );
    } );
  } );

  forms
    .find( getInputSelector( true ) )
    .on( 'focus', ( event ) =>
      $( event.target ).closest( 'p' ).addClass( 'focused' )
    )
    .on( 'blur change', updateFocusedState );

  /**
   * number only input (contact form 7 tel)
   */


  forms.find( '.wpcf7-tel' ).on( 'keypress', ( event ) => {
    validatePhoneNumberCharacter( event );
  } );

  forms.find( '.wpcf7-tel' ).on( 'paste', ( e ) => {
    e.preventDefault();

  } );

  forms
    .find( '[name=first-name], [name=last-name], [name=job-title]' )
    .on( 'keypress', ( event ) => {
      validateNameCharacter( event );
    } );


} );
